/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WalletHistory,
    WalletHistoryFromJSON,
    WalletHistoryFromJSONTyped,
    WalletHistoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface WalletHistoryDataFrame
 */
export interface WalletHistoryDataFrame {
    /**
     * 
     * @type {number}
     * @memberof WalletHistoryDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof WalletHistoryDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof WalletHistoryDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<WalletHistory>}
     * @memberof WalletHistoryDataFrame
     */
    data: Array<WalletHistory>;
}

export function WalletHistoryDataFrameFromJSON(json: any): WalletHistoryDataFrame {
    return WalletHistoryDataFrameFromJSONTyped(json, false);
}

export function WalletHistoryDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): WalletHistoryDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(WalletHistoryFromJSON)),
    };
}

export function WalletHistoryDataFrameToJSON(value?: WalletHistoryDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(WalletHistoryToJSON)),
    };
}


